module.exports = __webpack_public_path__ + "static/media/mt-sos-logo.a771ebbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/img/seals/MT/mt-sos-logo.png
// module id = 1489
// module chunks = 0